module.exports = __webpack_public_path__ + "static/media/title_bg_9.b43723b6.png";